import { render, staticRenderFns } from "./R2s4expense.vue?vue&type=template&id=0ed00c08&scoped=true&"
import script from "./R2s4expense.vue?vue&type=script&lang=js&"
export * from "./R2s4expense.vue?vue&type=script&lang=js&"
import style0 from "./R2s4expense.vue?vue&type=style&index=0&id=0ed00c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed00c08",
  null
  
)

export default component.exports